webpackJsonp([35783957827783],{

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Profile.prototype.render = function render() {
	    var pathPrefix =  false ? '' : ("");
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'section',
	        { id: 'profile', className: 'text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement('img', {
	            src: pathPrefix + '/img/profile.jpg',
	            className: 'rounded-circle mx-auto d-block u-img-popup',
	            width: '120',
	            height: '120'
	          }),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'yagi_suke'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead text-muted text-center' },
	            '\u9031\u672B\u306F\u767B\u5C71\u304B\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u304B'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                ref: 'twButton',
	                href: 'https://twitter.com/yagi_suke',
	                className: 'twitter-follow-button',
	                'data-show-count': 'false'
	              },
	              'Follow @yagi_suke'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'features', className: 'bg-primary text-white text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'u-font-mono' },
	                'Features'
	              ),
	              _react2.default.createElement('hr', { className: 'border-white' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-md-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-8' },
	              _react2.default.createElement(
	                'p',
	                { className: 'text-center' },
	                '\u30D0\u30C3\u30AF\u30A8\u30F3\u30C9\u3068\u30D5\u30ED\u30F3\u30C8\u30A8\u30F3\u30C9\u3092\u9694\u3066\u306A\u304F\u958B\u767A\u3057\u3066\u304D\u307E\u3057\u305F\u3002 \u6700\u8FD1\u3067\u306F\u3001\u30D5\u30ED\u30F3\u30C8\u30A8\u30F3\u30C9\u306E\u9AD8\u54C1\u8CEA\u5316\u306B\u6CE8\u529B\u3057\u3001\u30DE\u30CD\u30B8\u30E1\u30F3\u30C8\u696D\u52D9\u3082\u62C5\u5F53\u3002 \u4ECA\u5F8C\u306F\u958B\u767A\u306E\u7ACB\u5834\u304B\u3089\u3001\u4E8B\u696D\u306E\u6210\u9577\u306B\u8CA2\u732E\u3057\u3066\u3044\u304D\u305F\u3044\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'works', className: 'text-center color-inverse' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'u-font-mono' },
	                'Works'
	              ),
	              _react2.default.createElement('hr', { className: 'border-primary' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row c-works' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6 col-md-4 c-works__list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__top' },
	                    _react2.default.createElement('img', {
	                      src: pathPrefix + '/img/work/work-1.png',
	                      alt: 'RegionUP',
	                      className: 'c-works__top__img'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__skills' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'Java'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'JavaScript'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'jQuery'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'HTML'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'CSS'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/regionup/',
	                      className: 'btn btn-outline-primary btn-block'
	                    },
	                    '\u3082\u3063\u3068\u898B\u308B'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6 col-md-4 c-works__list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__top' },
	                    _react2.default.createElement('img', {
	                      src: pathPrefix + '/img/work/work-2.png',
	                      alt: '\u30BC\u30AF\u30B7\u30A3',
	                      className: 'c-works__top__img'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__skills' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'JavaScript'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'jQuery'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'HTML'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'CSS'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/zexy/',
	                      className: 'btn btn-outline-primary btn-block'
	                    },
	                    '\u3082\u3063\u3068\u898B\u308B'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6 col-md-4 c-works__list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__top' },
	                    _react2.default.createElement('img', {
	                      src: pathPrefix + '/img/work/work-3.png',
	                      alt: 'HOT PEPPER Beauty',
	                      className: 'c-works__top__img'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__skills' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'Java'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'Oracle'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/hotpepper-beauty/',
	                      className: 'btn btn-outline-primary btn-block'
	                    },
	                    '\u3082\u3063\u3068\u898B\u308B'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6 col-md-4 c-works__list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__top' },
	                    _react2.default.createElement('img', {
	                      src: pathPrefix + '/img/work/work-4.png',
	                      alt: 'careertrek',
	                      className: 'c-works__top__img'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__skills' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'Java'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'MySQL'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/careertrek/',
	                      className: 'btn btn-outline-primary btn-block'
	                    },
	                    '\u3082\u3063\u3068\u898B\u308B'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-6 col-md-4 c-works__list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__top' },
	                    _react2.default.createElement('img', {
	                      src: pathPrefix + '/img/work/work-5.png',
	                      alt: '\u3058\u3083\u3089\u3093',
	                      className: 'c-works__top__img'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'c-works__skills' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'JavaScript'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'React/Redux'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'HTML'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'badge badge-primary text-white' },
	                      'CSS'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/jalan-business-support/',
	                      className: 'btn btn-outline-primary btn-block'
	                    },
	                    '\u3082\u3063\u3068\u898B\u308B'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'skills', className: 'bg-primary text-white text-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'u-font-mono' },
	                'Skills'
	              ),
	              _react2.default.createElement('hr', { className: 'border-white' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-md-center c-skills' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'Java'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-java-plain-wordmark c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'MySQL'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-mysql-plain-wordmark c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'ORACLE'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-oracle-original c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'HTML5'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-html5-plain-wordmark c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row justify-content-md-center c-skills' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'CSS3'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-css3-plain-wordmark c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'JavaScript'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-javascript-plain c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'React'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-react-original-wordmark c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-3 col-6 ' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'c-skills__box',
	                  'data-toggle': 'tooltip',
	                  'data-placement': 'top',
	                  title: 'jQuery'
	                },
	                _react2.default.createElement('i', {
	                  className: 'devicon-jquery-plain-wordmark c-skills__img',
	                  'data-emergence': 'hidden'
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Profile;
	}(_react.Component);
	
	exports.default = Profile;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-89cc68a00fac7f46a329.js